import {IStudyInstitutionJson} from 'core/api/study_coordinator'
import {IPayloadAction} from 'core/store'
import {Action, Reducer} from 'redux'

const SET_INSTITUTION = 'study-coordinator/SET_INSTITUTION'

interface IActionSetInstitution extends IPayloadAction<typeof SET_INSTITUTION, IStudyInstitutionJson> {}

export const setInstitution = (payload: IStudyInstitutionJson): IActionSetInstitution => ({
  type: SET_INSTITUTION,
  payload,
})

export type IState = IStudyInstitutionJson | null

const initialState: IState = null

type TAction = IActionSetInstitution

const unwrappedReducer = (state: IState = initialState, action: TAction): IState => {
  switch (action.type) {
    case SET_INSTITUTION:
      return action.payload
    default:
      return state
  }
}

// TODO: Workaround for redux typings issue. Fixed in redux v4.
// https://github.com/reactjs/redux/issues/2709
export const reducer: Reducer<IState> = (state: IState, action: Action) => (
  unwrappedReducer(state, action as TAction)
)



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_coordinator/src/store/study-coordinator/institution.ts